/**
 * @jsxRuntime classic
 * @jsx jsx
 */
/** @jsxfrag */

import React, { type ReactNode } from 'react';

import { jsx } from '@compiled/react';

import { Box, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';

type BeforeTabProps = {
	elementBefore?: ReactNode | undefined;
};

const BeforeTab = ({ elementBefore }: BeforeTabProps) =>
	elementBefore ? (
		<>
			<Box
				xcss={elementBeforeStyles}
				style={{
					// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
					display: 'var(--display-icon-before, flex)',
				}}
			>
				{elementBefore}
			</Box>
		</>
	) : null;

const elementBeforeStyles = xcss({
	inlineSize: token('space.300', '24px'),
	blockSize: token('space.300', '24px'),
	alignItems: 'center',
	justifyContent: 'center',
});

export default BeforeTab;
